import { createAppReducer } from 'lib/redux/reducerUtils'
import { API_CALL_FAILURE, API_CALL_REQUEST, API_CALL_SUCCESS } from 'actions/actionConstants'
import { apiCalls } from './businessTravellerApiActionReducers'

export const BUSINESS_TRAVELLER_INITIAL_STATE: App.BusinessTravellerState = {
  currentBusinessAccount: undefined,
  businessOffices: { status: 'pending', all: {} },
  offersCredits: {},
  itemPolicyBudgets: {},
  itemPolicyCalculatedCredits: {},
  serviceFees: {},
  businessBudgets: {},
  businessAccommodationPolicy: { status: 'pending', policy: undefined },
  businessFlightPolicy: { status: 'pending', policy: undefined },
  businessCarHirePolicy: { status: 'pending', policy: undefined },
  businessFlightBudgets: {},
  businessCarHireBudgets: {},
  businessApprovalPolicy: { status: 'pending', policy: undefined },
  budgets: {},
  flightSearchBudget: {},
  onboarding: undefined,
  employeeNotification: undefined,
  employeeSociete: undefined,
  employees: { status: 'pending', all: {} },
  approvers: { status: 'pending', all: {} },
  selectedTravellerEmployeeIds: [],
  selectedTravellerGuestCount: 0,
  selectedTravellerGuestIds: [],
  approvalRequestId: undefined,
  businessMapBudget: undefined,
  employeeDetails: { status: 'pending', all: [] },
  businessCards: { status: 'pending', cards: [] },
  flightBudgetNotification: undefined,
}

export enum BUSINESS_TRAVELLER_ACTIONS {
  SET_BUSINESS_TRAVELLER = 'BUSINESS_TRAVELLER_SET_BUSINESS_TRAVELLER',
  UPDATE_CREDIT_CUSTOMER_DETAILS = 'BUSINESS_TRAVELLER_UPDATE_CREDIT_CUSTOMER_DETAILS',
  SET_BUSINESS_MAP_BUDGET = 'BUSINESS_TRAVELLER_SET_BUSINESS_MAP_BUDGET',
  UPDATE_EMPLOYEE_LOYALTY_PROGRAMS = 'BUSINESS_TRAVELLER_UPDATE_EMPLOYEE_LOYALTY_PROGRAMS',
}

const businessTravellerReducer = createAppReducer<App.BusinessTravellerState>(
  BUSINESS_TRAVELLER_INITIAL_STATE,
  {
    [API_CALL_REQUEST]: (state, action) => apiCalls(state, action),
    [API_CALL_SUCCESS]: (state, action) => apiCalls(state, action),
    [API_CALL_FAILURE]: (state, action) => apiCalls(state, action),
    [BUSINESS_TRAVELLER_ACTIONS.SET_BUSINESS_MAP_BUDGET]: (_state, action) => {
      return {
        businessMapBudget: action.businessMapBudget,
      }
    },
    [BUSINESS_TRAVELLER_ACTIONS.SET_BUSINESS_TRAVELLER]: (state, action) => {
      return {
        selectedTravellerEmployeeIds: action.employeeIds ?? state.selectedTravellerEmployeeIds,
        selectedTravellerGuestCount: action.guestCount ?? state.selectedTravellerGuestCount,
        selectedTravellerGuestIds: action.guestIds ?? state.selectedTravellerGuestIds,
      }
    },
    [BUSINESS_TRAVELLER_ACTIONS.UPDATE_CREDIT_CUSTOMER_DETAILS]: (state, action) => {
      if (!state.currentBusinessAccount?.employee || !state.currentBusinessAccount?.business) {
        return state
      }
      return {
        ...state,
        currentBusinessAccount: {
          status: 'success',
          business: state.currentBusinessAccount.business,
          employee: {
            ...state.currentBusinessAccount.employee,
            creditCustomerEmail: action.creditCustomerEmail,
          },
        },
      }
    },
    [BUSINESS_TRAVELLER_ACTIONS.UPDATE_EMPLOYEE_LOYALTY_PROGRAMS]: (state, action) => {
      if (state.currentBusinessAccount?.status !== 'success' || !state.currentBusinessAccount.employee) {
        return state
      }
      return {
        ...state,
        currentBusinessAccount: {
          ...state.currentBusinessAccount,
          employee: {
            ...state.currentBusinessAccount.employee,
            ...(action.flightPrograms !== undefined && { employeeFrequentFlyer: action.flightPrograms }),
            ...(action.hotelPrograms !== undefined && { employeeHotelLoyaltyPrograms: action.hotelPrograms }),
          },
        },
      }
    },
  },
)

export default businessTravellerReducer
